// @i18n-ignore-file
// Constants
import { ExperimentConfiguration } from '../experiments.types'

// Types

const EXPERIMENT_CONFIG_LIST: ExperimentConfiguration[] = [
  {
    name: 'pdp-new-tab',
    date: '2024-03-05',
    buckets: [
      { name: 'control', ratio: 100 },
      { name: 'show', ratio: 0 },
    ],
  },
  {
    name: 'default-cart-recommendation',
    date: '2024-04-30',
    buckets: [
      { name: 'show', ratio: 100 },
      { name: 'control', ratio: 0 },
    ],
  },
]

Object.freeze(EXPERIMENT_CONFIG_LIST)

export default EXPERIMENT_CONFIG_LIST
